import styled from 'styled-components'
import { Pill, Table, TableComponents } from '@sketch/components'

export const StyledPill = styled(Pill)`
  max-width: 100%;
`

export const StyledAuditLogTable = styled(Table)`
  width: 100%;
  table-layout: fixed;

  ${/* sc-selector */ TableComponents.TableHeaderCell}:nth-child(1) {
    width: 164px;
  }

  ${/* sc-selector */ TableComponents.TableHeaderCell}:nth-child(2) {
    width: 124px;
  }

  ${/* sc-selector */ TableComponents.TableHeaderCell}:nth-child(4) {
    width: 50px;
  }

  ${/* sc-selector */ TableComponents.TableCell}:nth-child(3) {
    overflow-wrap: anywhere;
  }

  ${/* sc-selector */ TableComponents.TableCell}:nth-child(4) {
    text-align: right;
  }
` as typeof Table

export const DetailsCell = styled(TableComponents.TableCell)`
  overflow-wrap: anywhere;
  padding: 8px 0 8px 12px;
`
